export const totalRentConcept = (days, price, size = 1) => {
    return days * price * size;
}

export const diffDates = (firstDate, lastDate) => {
    const fechaInicio = new Date(firstDate).getTime();
    const fechaFin = new Date(lastDate).getTime();
    return ((fechaFin - fechaInicio)/(1000*60*60*24))+1 ;
}

export const totalCompleteRent = (array) => {
    let price = 0;

    array.forEach((el) => {
        price += el.size * el.price * el.rentsDays;
    })
    return price
}

export const totalRent = (array) => {
    let price = 0;
    array.forEach((el) => {
        price += el.amount * el.priceProduct;
    })
    return price
}

export const totalCertification = (arrayProduct, totalRents) => {
    let price = 0;
    price += totalRent(arrayProduct);
    price += totalRents;

    return price;
}

export function calculateIva(amount, percentage) {
    const iva = (percentage === '21%') ? 0.21 : 0.10;
    return (amount * iva).toFixed(2);
}

export function calculateTotalWithIva(amount, percentage) {
    const iva = (percentage === '21%') ? 1.21 : 1.10;
    return (amount * iva).toFixed(2);
}